
export default { name: "back-white" };
